import './Preloader.css'

function Preloader() {
   return(
    <>
      <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </>
   )
}

export default Preloader;